module.exports = __webpack_public_path__ + "assets/img/Partners2x.40384f1c.png";